import { orchestrator } from 'satcheljs';
import {
    GetFolderIdsData,
    GetFolderIdsDataType,
    initializeUpNextEventLoader,
} from 'owa-upnext-event-loader';
import { getSelectedCalendars } from 'owa-selected-calendars-user-config';
import { getUserMailboxId } from 'owa-client-ids';
import { initializeUpNextV2 } from '../actions/publicActions';

export default orchestrator(initializeUpNextV2, actionMessage => {
    // Selected calendars are the calendars that user has selected in Calendar module left nav
    // For Upnext event we will get the upcoming event in any of these selected calendars
    const selectedCalendarIds = getSelectedCalendars(getUserMailboxId()) || [];
    const getFolderIdsData: GetFolderIdsData =
        selectedCalendarIds.length !== 0
            ? {
                  loaderType: GetFolderIdsDataType.CalendarIds,
                  calendarIds: selectedCalendarIds,
              }
            : {
                  loaderType: GetFolderIdsDataType.DefaultCalendar,
              };
    initializeUpNextEventLoader(getFolderIdsData, 'TimePanelAgenda_UpNextCalendarCacheId');
});
